import React from 'react'
import styled from 'styled-components'
import { TYPE } from 'theme'
import { AutoColumn } from './Column'
import { CardBGImage, CardNoise, CardSection, DataCard } from './farm/styled'
import { RowBetween } from './Row'

const VoteCard = styled(DataCard)`
  overflow: hidden;
  border: 1px solid #2d3131;
  box-shadow: 0 0 1px 1px #0b0d0e;
  white-space: pre-line;
  backdrop-filter: blur(4px) saturate(150%);
`

export function InfoCard({
  title,
  description,
  style,
}: {
  title: string
  description: string | React.ReactNode
  style?: any
}) {
  return (
    <VoteCard style={style}>
      <CardBGImage />
      <CardSection>
        <AutoColumn gap="md">
          <RowBetween>
            <TYPE.white fontSize={18} fontWeight={600}>
              {title}
            </TYPE.white>
          </RowBetween>
          <RowBetween>
            <TYPE.white fontSize={14}>{description}</TYPE.white>
          </RowBetween>
        </AutoColumn>
      </CardSection>
      <CardBGImage />
      <CardNoise />
    </VoteCard>
  )
}
